import type { Priority, Potential, ApoioTipo, TodoPriority } from "@/types";

export const SK = {
  DOCTORS: "mv5_doctors",
  VISITS: "mv5_visits",
  PERIOD: "mv5_period",
  PERIOD_HISTORY: "mv5_ph",
  PLAN: "mv5_plan", // append date: mv5_plan_YYYY-MM-DD
  PRODUCTS: "mv5_products",
  ZONES: "mv5_zones",
  APOIOS: "mv5_apoios",
  TODOS: "mv5_todos",
} as const;

export function planKey(date: string) {
  return `${SK.PLAN}_${date}`;
}

export const PRIO_TARGET: Record<Priority, number> = {
  baixa: 1,
  media: 2,
  alta: 3,
};

export const PRIO_LABELS: Record<Priority, string> = {
  alta: "Alta",
  media: "Média",
  baixa: "Baixa",
};

export const POT_LABELS: Record<Potential, string> = {
  alto: "Alto",
  medio: "Médio",
  baixo: "Baixo",
};

export const POT_BONUS: Record<Potential, number> = {
  alto: 10,
  medio: 5,
  baixo: 0,
};

export const APOIO_LABELS: Record<ApoioTipo, string> = {
  inscricao: "Inscrição",
  inscricao_aloj: "Insc. + Alojamento",
  completo: "Completo",
};

export const TODO_PRIO_LABELS: Record<TodoPriority, string> = {
  alta: "Alta",
  normal: "Normal",
  baixa: "Baixa",
};

export const DAYS = ["", "Seg", "Ter", "Qua", "Qui", "Sex"];

export function todayKey(): string {
  return new Date().toISOString().slice(0, 10);
}

export function currentQuarter(): { start: string; end: string } {
  const now = new Date();
  const y = now.getFullYear();
  const q = Math.floor(now.getMonth() / 3);
  const start = new Date(y, q * 3, 1);
  const end = new Date(y, q * 3 + 3, 0);
  return {
    start: start.toISOString().slice(0, 10),
    end: end.toISOString().slice(0, 10),
  };
}

export type PeriodPreset = {
  label: string;
  fn: () => { start: string; end: string };
};

export const PERIOD_PRESETS: PeriodPreset[] = (() => {
  const y = new Date().getFullYear();
  const iso = (d: Date) => d.toISOString().slice(0, 10);
  return [
    { label: "1.º Trimestre", fn: () => ({ start: iso(new Date(y, 0, 1)), end: iso(new Date(y, 2, 31)) }) },
    { label: "2.º Trimestre", fn: () => ({ start: iso(new Date(y, 3, 1)), end: iso(new Date(y, 5, 30)) }) },
    { label: "3.º Trimestre", fn: () => ({ start: iso(new Date(y, 6, 1)), end: iso(new Date(y, 8, 30)) }) },
    { label: "4.º Trimestre", fn: () => ({ start: iso(new Date(y, 9, 1)), end: iso(new Date(y, 11, 31)) }) },
    { label: "1.º Semestre", fn: () => ({ start: iso(new Date(y, 0, 1)), end: iso(new Date(y, 5, 30)) }) },
    { label: "2.º Semestre", fn: () => ({ start: iso(new Date(y, 6, 1)), end: iso(new Date(y, 11, 31)) }) },
    { label: "Ano Completo", fn: () => ({ start: iso(new Date(y, 0, 1)), end: iso(new Date(y, 11, 31)) }) },
    { label: "Mês Atual", fn: () => {
      const now = new Date();
      return { start: iso(new Date(now.getFullYear(), now.getMonth(), 1)), end: iso(new Date(now.getFullYear(), now.getMonth() + 1, 0)) };
    }},
  ];
})();
